import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import {
  DARK_GREEN_BOX,
  DARK_RED_BOX,
  GREEN_COLOR,
  LIGHT_GREEN_BOX,
  LIGHT_RED_BOX,
  RED_COLOR,
} from '../../../const/color-const';
import MoneyFormat from '../../common/MoneyFormat';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch/Switch';

const useStyles = makeStyles(theme => ({
  boxContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  boxValue: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '30px',
    letterSpacing: '-0.3px',
    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 24,
      letterSpacing: 'normal',
    },
  },
  greenBadge: {
    border: `1px solid ${GREEN_COLOR}`,
    color: GREEN_COLOR,
    marginLeft: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
  },
  redBadge: {
    border: `1px solid ${RED_COLOR}`,
    color: RED_COLOR,
    marginLeft: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
  },
  boxBadge: {
    borderRadius: '4px',
    textTransform: 'uppercase',
    textAlign: 'center',
    lineHeight: '18px',
    display: 'inline-flex',
    fontSize: 14,
    alignItems: 'center',
    fontWeight: 'bold',
    padding: '2px 6px',
    height: '24px',
  },
  valueWithVAT: {
    display: 'flex',
    alignItems: 'center',
  },
  additionalInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    marginTop: theme.spacing(0.5),
    fontSize: 12,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      width: '48%',
    },
  },
  vatWrapper: {
    marginTop: theme.spacing(0.5),
    textAlign: 'center',
  },
  percentageDiffWrapper: {
    marginTop: theme.spacing(0.5),
    textAlign: 'center',
  },
  differenceText: {
    color: theme.palette.type === 'light' ? 'black' : 'white',
    padding: theme.spacing(0, 0.5, 0, 0.5),
    margin: 0,
  },
  diffBox: {
    padding: theme.spacing(0.2, 0.5, 0.2, 0.5),
    color: 'white',
    borderRadius: 4,
  },
  increase: {
    background: theme.palette.type === 'light' ? LIGHT_GREEN_BOX : DARK_GREEN_BOX,
  },
  decrease: {
    background: theme.palette.type === 'light' ? LIGHT_RED_BOX : DARK_RED_BOX,
  },
  vatComponent: {
    fontSize: 11,
    marginTop: 5,
    display: 'flex',
    marginBottom: 10,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: 12,
    },
  },
}));

const SalesBar = (props) => {
  const { salesInclVat, salesExclVat, vat, progressDiff } = props;
  const [isVat, setIsVat] = useState(true);
  const classes = useStyles();
  const isPositive = (num) => num >= 0;
  const renderVatData = isVat && vat !== 0;
  const renderVatSwitch = salesInclVat !== salesExclVat;
  const renderProgressDiff = !isNaN(progressDiff) && Number(progressDiff);
  
  return <div className={classes.boxContent}>
    <div className={classes.valueWithVAT}>
                <span className={classes.boxValue}>
                  <MoneyFormat value={isVat ? salesInclVat : salesExclVat} decimalScale={0} /> kr
                </span>
    </div>
    
    <div className={classes.additionalInfo}>
      {renderVatData && <div className={classes.vatWrapper}>
        <FormattedMessage
          id="page.dashboard.ofWhichVAT"
          defaultMessage="Of which VAT"
        />:
        <br />
        <b> <MoneyFormat value={vat} decimalScale={0} /> kr</b>
      </div>}
      {renderProgressDiff && <div className={classes.percentageDiffWrapper}>
        <span className={classNames(classes.diffBox,
          isPositive(progressDiff) ? classes.increase : classes.decrease)}>
          {progressDiff}%
        </span>
        <p className={classes.differenceText}>
          <FormattedMessage
            id="of.prev.period"
            defaultMessage="of last period"
          />
        </p>
      </div>}
    </div>
    
    {renderVatSwitch && <div className={classes.vatComponent}>
      <FormattedMessage id="report.chart.SalesExclVAT" defaultMessage="Sales excl VAT" />
      <Switch color="primary" checked={isVat} onChange={() => setIsVat(!isVat)} />
      <FormattedMessage id="report.chart.SalesInclVAT" defaultMessage="Sales incl VAT" />
    </div>}
  </div>;
};

SalesBar.propTypes = {
  sales: PropTypes.number,
  salesVat: PropTypes.number,
  progressDiff: PropTypes.number,
};

export default SalesBar;